import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class TosterService {

  constructor(private toastr: ToastrService) { }
  showSuccess(msgString :string){
    this.toastr.success(msgString, 'Success', {
   timeOut: 500,
 });
   }
   showError(){
    this.toastr.error('everything is broken', 'Major Error', {
   timeOut: 500,
 });
   }
    showInfo(){
    this.toastr.info('everything is broken', 'Major Error', {
   timeOut: 500,
 });
   }
    showWarning(){
    this.toastr.warning('everything is broken', 'Major Error', {
   timeOut: 500,
 });
   }
}
